var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsurance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "insurance-clipboard-document-report-security"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#ff7956",
    height: 52,
    rx: 2,
    width: 42,
    x: 3,
    y: 9,
    "data-original": "#ff7956",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 11v48a2.006 2.006 0 0 1 -2 2h-4a2.006 2.006 0 0 0 2-2v-48a2.006 2.006 0 0 0 -2-2h4a2.006 2.006 0 0 1 2 2z",
    fill: "#ff5023",
    "data-original": "#ff5023",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 13h34v44h-34z",
    fill: "#fee9ab",
    "data-original": "#fee9ab",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 13h4v44h-4z",
    fill: "#ffd422",
    "data-original": "#ffd422",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 36v13.78a7.977 7.977 0 0 1 -4.26 7.07l-8.74 4.15-3.08-1.46-5.34-2.54-.32-.15a7.953 7.953 0 0 1 -3.94-4.85 7.84 7.84 0 0 1 -.32-2.22v-13.78h1a15.724 15.724 0 0 0 5-.81 15.975 15.975 0 0 0 4-1.96c.2-.14.4-.28.6-.43l2.4-1.8 2.4 1.8a16.119 16.119 0 0 0 9.6 3.2z",
    fill: "#ffcd00",
    "data-original": "#ffcd00",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 36v13.78a7.977 7.977 0 0 1 -4.26 7.07l-8.74 4.15-2-.95 6.74-3.2a7.977 7.977 0 0 0 4.26-7.07v-13.78h-1a16.119 16.119 0 0 1 -9.6-3.2l-.4-.3 2-1.5 2.4 1.8a16.119 16.119 0 0 0 9.6 3.2z",
    fill: "#ebbf00",
    "data-original": "#ebbf00",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 39.77v10.01a3.993 3.993 0 0 1 -2.07 3.5l-6.93 3.29-6.93-3.29a3.993 3.993 0 0 1 -2.07-3.5v-10.01a20.08 20.08 0 0 0 9-3.77 20.08 20.08 0 0 0 9 3.77z",
    fill: "#ffe477",
    "data-original": "#ffe477",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 39.77v10.01a3.993 3.993 0 0 1 -2.07 3.5l-6.93 3.29-2-.95 4.93-2.34a3.993 3.993 0 0 0 2.07-3.5v-10.01a20.042 20.042 0 0 1 -7-2.46 18.575 18.575 0 0 0 2-1.31 20.08 20.08 0 0 0 9 3.77z",
    fill: "#ffd422",
    "data-original": "#ffd422",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 9v5h-20v-5a2.006 2.006 0 0 1 2-2h3.1a5 5 0 0 1 9.8 0h3.1a2.006 2.006 0 0 1 2 2z",
    fill: "#acabb1",
    "data-original": "#acabb1",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 9v5h-4v-5a2.006 2.006 0 0 0 -2-2h-3.1a4.986 4.986 0 0 0 -2.9-3.58 4.941 4.941 0 0 1 2-.42 5 5 0 0 1 4.9 4h3.1a2.006 2.006 0 0 1 2 2z",
    fill: "#898890",
    "data-original": "#898890",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 22v4h-4v4h-4v-4h-4v-4h4v-4h4v4z",
    fill: "#ff3051",
    "data-original": "#ff3051",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 22v4h-4v4h-2v-12h2v4z",
    fill: "#cd2a00",
    "data-original": "#cd2a00",
    style: {}
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 8,
    fill: "#787680",
    r: 2,
    "data-original": "#787680",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 8a2 2 0 0 1 -3 1.73 2 2 0 0 0 0-3.46 2 2 0 0 1 3 1.73z",
    fill: "#57565c",
    "data-original": "#57565c",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 5a3 3 0 1 0 3 3 3 3 0 0 0 -3-3zm0 4a1 1 0 1 1 1-1 1 1 0 0 1 -1 1z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 33h4v2h-4z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 33h15v2h-15z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 39h4v2h-4z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 45h4v2h-4z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 51h4v2h-4z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 35h-1a15.113 15.113 0 0 1 -9-3l-2.4-1.8a.99.99 0 0 0 -1.2 0l-1.4 1.05v-20.25a3.009 3.009 0 0 0 -3-3h-8.18a3.01 3.01 0 0 0 -2.82-2h-2.34a6 6 0 0 0 -11.32 0h-2.34a3.01 3.01 0 0 0 -2.82 2h-8.18a3.009 3.009 0 0 0 -3 3v48a3.009 3.009 0 0 0 3 3h38a3.016 3.016 0 0 0 2.35-1.15l2.22 1.05a.975.975 0 0 0 .86 0l8.78-4.17a8.961 8.961 0 0 0 4.79-7.95v-13.78a1 1 0 0 0 -1-1zm-26-25h8a1 1 0 0 1 1 1v21.69a15.237 15.237 0 0 1 -2 1.05v-20.74a1 1 0 0 0 -1-1h-6zm-20-1a1 1 0 0 1 1-1h3.1a.988.988 0 0 0 .98-.8 4 4 0 0 1 7.84 0 .988.988 0 0 0 .98.8h3.1a1 1 0 0 1 1 1v4h-18zm-1 6h20a1 1 0 0 0 1-1h5v20.44a15.03 15.03 0 0 1 -4 .56h-1a1 1 0 0 0 -1 1v3h-17v2h17v4h-17v2h17v2.78a9.867 9.867 0 0 0 .08 1.22h-17.08v2h17.61a9.027 9.027 0 0 0 1.91 3h-28.52v-42h5a1 1 0 0 0 1 1zm29 45h-38a1 1 0 0 1 -1-1v-48a1 1 0 0 1 1-1h8v2h-6a1 1 0 0 0 -1 1v44a1 1 0 0 0 1 1h32.36l4.02 1.91a1.007 1.007 0 0 1 -.38.09zm17-10.22a6.953 6.953 0 0 1 -3.69 6.16l-8.31 3.95-8.29-3.94a6.975 6.975 0 0 1 -3.71-6.17v-12.78a17.1 17.1 0 0 0 10.2-3.4l1.8-1.35 1.8 1.35a17.1 17.1 0 0 0 10.2 3.4z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 21h-3v-3a1 1 0 0 0 -1-1h-4a1 1 0 0 0 -1 1v3h-3a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h3v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-3h3a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1zm-1 4h-3a1 1 0 0 0 -1 1v3h-2v-3a1 1 0 0 0 -1-1h-3v-2h3a1 1 0 0 0 1-1v-3h2v3a1 1 0 0 0 1 1h3z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.15 38.78a19.042 19.042 0 0 1 -8.55-3.58.99.99 0 0 0 -1.2 0 19.042 19.042 0 0 1 -8.55 3.58 1.008 1.008 0 0 0 -.85.99v10.01a4.994 4.994 0 0 0 2.58 4.37l.06.03 6.93 3.29a.975.975 0 0 0 .86 0l6.99-3.32a5.006 5.006 0 0 0 2.58-4.37v-10.01a1.008 1.008 0 0 0 -.85-.99zm-1.15 11a2.959 2.959 0 0 1 -1.5 2.59l-6.5 3.09-6.48-3.07a3 3 0 0 1 -1.52-2.61v-9.17a21.108 21.108 0 0 0 8-3.38 21.108 21.108 0 0 0 8 3.38z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.707 47.293-1.414 1.414 3 3a1 1 0 0 0 1.414 0l8-8-1.414-1.414-7.293 7.293z",
    fill: "#000000",
    "data-original": "#000000",
    style: {}
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "orders/static/media/insurance.21bff5431015a505f2729dfa980a6cec.svg";
export { ForwardRef as ReactComponent };